<template>

  <!-- <div class="main-content"> -->
  <div class="login" id='dicai-login'>
    <div class="main-left" id='swiper-img'>
      <!-- <div style="padding-left:40px;"> -->
      <swiper :options="swiperOption" id='swiper-slide-img' style="width: 100%;">
        <swiper-slide v-for="(item, index) in swiperSlides" v-bind:key="item.res_url"> <a :href="item.link" target="_blank"><img
              :src="item.res_url" class="swiper-slide-media" /></a></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
        <div class="swiper-button-prev iconfont iconjiantouzuo" slot="button-prev"></div>
        <div class="swiper-button-next iconfont iconjiantouyou" slot="button-next"></div>
      </swiper>
      <!-- </div> -->
    </div>
    <div class="register-form">
      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="0" class="demo-ruleForm">
        <div class="login-user">您好！请登录</div>
        <el-form-item prop="username">
          <el-input placeholder='账号' v-model.number="ruleForm2.username"></el-input>
        </el-form-item>
        <el-form-item class='form-input' prop="password" style="color: #fff;">
          <el-input type="password" name="password" placeholder='密码' v-model="ruleForm2.password" auto-complete='off'></el-input>
        </el-form-item>
        <div class="record"> <span v-if="state=='1'"><input type="checkbox" checked @click="CheckItem(state)" v-model="state"
              name="checkbox" style="width: 20px;height: 20px;"></span>
          <span v-else @click="CheckItem(state)"><input type="checkbox" name="checkbox" style="width: 20px;height: 20px;"></span>
          <div>记住密码</div>
        </div>
        <el-button type="primary" @click="login()" class="submit-login">登录</el-button>
        <!-- <button class="submit-login" @click="_autoLogin()">登录</button> -->
      </el-form>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
  import "swiper/dist/css/swiper.css";
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  export default {
    name: 'login',
    components: {
      swiper,
      swiperSlide
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        }
      };
      var validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号'));
        }
      };
      return {
        ruleForm2: {
          password: '',
          username: ''
        },
        rules2: {
          password: [{
            validator: validatePass,
            trigger: 'blur'
          }],
          username: [{
            validator: validateName,
            trigger: 'blur'
          }]
        },
        swiperSlides: [

        ],
        state: localStorage.getItem('state'),
        swiperOption: {
          autoplay: 3000,
          autoplay: true,
          //可选选项，自动滑动
          loop: true, //开启轮播图前后循环模式
          pagination: {
            el: '.swiper-pagination'
          },
          navigation: {
            nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
            prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
            hideOnClick: true, //点击slide时显示/隐藏按钮
            disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
            hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
          },
        },

      };
    },
    created: function() {
      var me = this;
      document.onkeydown = function(event) {
        var e = event || window.event || arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 13) { // enter 键
          if (!localStorage.getItem('authorization')) {
            me.login();
          }

        }
      };
      me.ruleForm2.username = localStorage.getItem('username');
      if (me.state == '1') {
        me.ruleForm2.password = localStorage.getItem('password');
      } else {
        me.ruleForm2.password = ''
      }
      localStorage.setItem('authorization', '');
      localStorage.setItem('CLIENT_EXPIRES', '');
      me.reloadImage();
    },
    methods: {
      //首页图片
      reloadImage: function() {
        this.https.GetRequest('/pc/service/banner/default/index?page_id=1&position_id=2&limit=10').then((res) => {
          var data = res.data.content;
          if (res.data.success) {
            this.swiperSlides = data;
          }
          var box = document.getElementById("swiper-img").offsetWidth;
          document.getElementById("swiper-slide-img").style.height = box / 2 + 'px';
          document.getElementById("dicai-login").style.height = (box / 2) + 'px';
        }).catch(err => {
          console.log(err)
        })
      },
      //登录
      login(formName) {
        var me = this;
        if (me.ruleForm2.username === '') {
          this.$message({
            type: 'warning',
            message: '请输入账号'
          });
          return;
        }
        if (me.ruleForm2.password === '') {
          this.$message({
            type: 'warning',
            message: '请输入登录密码'
          });
          return;
        }
        let params = {
          grant_type: 'password',
          client_id: 'dealer',
          username: me.ruleForm2.username,
          password: me.ruleForm2.password
        }
        this.https.PostRequest('/pc/user/login-proccess', params).then((res) => {
          var data = res.data.content;
          if (res.data.success) {
            localStorage.setItem('authorization', data.access_token);
            localStorage.setItem('CLIENT_EXPIRES', data.expires);
            me.getuserInfo();
            me.saveStorage();
          } else {
            // me.$message({
            // 	type: 'warning',
            // 	message: res.data.message
            // });
          }

        }).catch(err => {
          console.log(err)
        })
      },
      //获取用户信息
      getuserInfo: function() {
        var me = this;
        this.https.fetchPost('/pc/service/user/default/index').then((res) => {
          var data = res.data.content;
          if (res.data.success) {
            localStorage.setItem('fullname', data.fullname);
            me.$router.push('cat');
          } else {
            // me.$message({
            // 	type: 'warning',
            // 	message: res.data.message
            // });
          }

        }).catch(err => {
          console.log(err)
        })
      },
      //记住密码
      CheckItem: function() {
        this.state = this.state == '1' ? 0 : 1;
        this.saveStorage();
      },
      saveStorage: function() {
        // var username = this.state ? this.ruleForm2.username : '';
        var password = this.state ? this.ruleForm2.password : '';
        localStorage.setItem('username', this.ruleForm2.username);
        localStorage.setItem('password', password);
        localStorage.setItem('state', this.state);
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main-content {
    /* padding-bottom: 40px; */
  }

  .login {
    position: relative;
    /* min-height: calc(100vh - 180px); */
    padding: 50px 20px;
    min-width: 1400px;
  }

  .swiper-pagination {
    bottom: 20px !important;
  }

  .swiper-button-prev,
  .swiper-button-next {
    background: #999;
    color: #000;
    opacity: 0.5;
    width: 32px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    border-radius: 100%;
  }

  .register-form {
    position: absolute;
    top: 50%;
    right: 40px;
    width: 350px;
    height: 300px;
    background: #2281db;
    margin-top: -150px;
    border-radius: 10px;
  }

  .main-left {
    position: absolute;
    width: 70%;
    min-width: 900px;
    /* margin-left: 40px; */
    /* margin-top: 40px; */
    /* 	height: 500px; */
    /* margin-bottom: 40px; */
  }

  .demo-ruleForm {
    padding: 20px;
  }

  .el-carousel--horizontal {
    overflow-y: hidden;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .login-user {
    margin-bottom: 22px;
    color: #fff;
    text-align: center;
  }

  .submit-login {
    width: 100%;
    background: #409EFF;
    border: 0;
    color: #fff;
    border-radius: 5px;
    height: 40px;
    cursor: pointer;
  }

  .record {
    margin-bottom: 22px;
    text-align: left;
  }

  .record input {
    display: inline-block;
    vertical-align: middle;
  }

  .record div {
    font-size: 14px;
    color: #fff;
    margin-left: 20px;
    display: inline-block;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .swiper-slide-media {
    height: 100%;
    width: 100%;

  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue